<template>
    <transition name="fade">
        <div
            v-if="toast.opened"
            role="status"
            aria-live="polite"
            aria-atomic="true"
            class="fixed bottom-24 left-0 right-0 z-999 mx-auto max-w-72 rounded border border-theme-border bg-theme-button-bg p-2 text-center text-theme-text opacity-95 shadow"
        >
            <p class="m-0">{{ toast.text }}</p>
        </div>
    </transition>
</template>
<script>
import { mapMutations, mapState } from 'vuex';

export default {
    name: 'ComponentToast',
    computed: {
        ...mapState(['toast']),
    },
    watch: {
        'toast.text'() {
            if (this.toast.opened) {
                this.initCloseToast();
            }
        },
    },
    mounted() {
        this.initCloseToast();
    },
    methods: {
        ...mapMutations(['openToast', 'closeToast']),
        initCloseToast() {
            setTimeout(() => {
                this.closeToast();
            }, 3000);
        },
    },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    @apply transition-opacity duration-500;
}
.fade-enter,
.fade-leave-to {
    @apply opacity-0;
}
</style>
